import { Redirect } from 'expo-router';
import FavoriteEditorPage from 'features/menu/pages/favorites-page/favorite-editor/favorite-editor';

import {
  useExposeRemoveMenuFavoritesExperiment,
  useRemoveMenuFavoritesExperiment,
} from 'experiments/use-remove-menu-favorites-experiment';
import { routes } from 'utils/routing';

export default function MenuFavoriteEditRoute() {
  const removeMenuFavorites = useRemoveMenuFavoritesExperiment();

  useExposeRemoveMenuFavoritesExperiment();

  // Keep the deep-linked route mounted until the assignment settles so a control user can still
  // access Favorite editing after a cold-start refresh.
  if (removeMenuFavorites === undefined) {
    return null;
  }

  if (removeMenuFavorites) {
    return <Redirect href={routes.menu} />;
  }

  return <FavoriteEditorPage />;
}
